(function(){
  // 対象：text/textarea だけ（select等は除外）
  function isTextLike(el){
    return el && el.nodeType === 1 &&
           el.matches && el.matches('input[type="text"], input:not([type]), textarea');
  }

  // どのルールを適用するか nameで判定（ [] 付きにも対応）
  function ruleOf(el){
    const name = el.getAttribute?.('name') || '';
    if (name === 'properties[text-jp]' || name.startsWith('properties[text-jp]')) return 'JP_FULL';
    if (name === 'properties[text-en]' || name.startsWith('properties[text-en]')) return 'ASCII_ALNUM';
    return null;
  }

  // ---- ルールA: 全角日本語のみ（半角ASCII/半角カナNG） ----
  // 許可：ひらがな、全角カタカナ、拡張カタカナ、漢字(基本+拡張B〜I)、互換漢字、全角記号・全角スペース
  // 不許可：ASCII半角(\x20-\x7E)、半角ｶﾀｶﾅ(\uFF65-\uFF9F) など
  const JP_ALLOWED = [
    '\\u3040-\\u309F',        // Hiragana
    '\\u30A0-\\u30FF',        // Katakana (fullwidth)
    '\\u31F0-\\u31FF',        // Katakana Phonetic Extensions
    '\\u3400-\\u4DBF',        // CJK Ext A
    '\\u4E00-\\u9FFF',        // CJK Unified
    '\\uF900-\\uFAFF',        // CJK Compatibility
    '\\u3000-\\u303F',        // CJK Symbols & Punctuation (全角記号/全角スペース)
    '\\u{20000}-\\u{2FA1F}'   // CJK Ext B–I (サロゲート)
  ].join('');
  const JP_DISALLOWED = new RegExp('[^' + JP_ALLOWED + ']', 'gu');   // 許可以外を除去
  function sanitizeJP(s){ return (s || '').replace(JP_DISALLOWED, ''); }

  // ---- ルールB: 半角英数字のみ（A-Z a-z 0-9） ----
  const NON_ALNUM = /[^A-Za-z0-9 @!_.-]/g;
  function sanitizeAlnum(s){ return (s || '').replace(NON_ALNUM, ''); }


  // 文字列をカーソル位置へクリーン挿入
  function insertAtCursor(input, text, sanitizer){
    const cleaned = sanitizer(text);
    const s = input.selectionStart ?? input.value.length;
    const e = input.selectionEnd ?? input.value.length;
    const v = input.value || '';
    input.value = v.slice(0, s) + cleaned + v.slice(e);
    const pos = s + cleaned.length;
    if (input.setSelectionRange) input.setSelectionRange(pos, pos);
  }

  // ---- IME状態管理 ----
  document.addEventListener('compositionstart', e => {
    if (!isTextLike(e.target) || !ruleOf(e.target)) return;
    e.target._comp = true;
  }, true);
  document.addEventListener('compositionend', e => {
    if (!isTextLike(e.target)) return;
    const rule = ruleOf(e.target);
    if (!rule) return;
    e.target._comp = false;
    const cleaned = (rule === 'JP_FULL') ? sanitizeJP(e.target.value) : sanitizeAlnum(e.target.value);
    if (e.target.value !== cleaned) e.target.value = cleaned;
  }, true);

  // ---- beforeinput：差し込み自体を可能ならブロック ----
  document.addEventListener('beforeinput', e => {
    const t = e.target;
    if (!isTextLike(t) || t._comp) return;
    const rule = ruleOf(t);
    if (!rule || !(e.inputType && e.inputType.startsWith('insert'))) return;
    const data = e.data ?? '';
    if (!data) return;
    if (rule === 'JP_FULL') {
      // data中に不許可が含まれるならキャンセル
      if (data.replace(JP_DISALLOWED, '') !== data) e.preventDefault();
    } else if (rule === 'ASCII_ALNUM') {
      if (NON_ALNUM.test(data)) e.preventDefault();
    }
  }, true);

  // ---- 貼り付け/ドロップ：クリーン化して挿入 ----
  document.addEventListener('paste', e => {
    const t = e.target; if (!isTextLike(t)) return;
    const rule = ruleOf(t); if (!rule) return;
    e.preventDefault();
    const txt = (e.clipboardData || window.clipboardData).getData('text');
    insertAtCursor(t, txt, rule === 'JP_FULL' ? sanitizeJP : sanitizeAlnum);
  }, true);

  document.addEventListener('drop', e => {
    const t = e.target; if (!isTextLike(t)) return;
    const rule = ruleOf(t); if (!rule) return;
    const dt = e.dataTransfer; if (!dt) return;
    const txt = dt.getData('text/plain');
    if (txt){
      e.preventDefault();
      t.focus();
      insertAtCursor(t, txt, rule === 'JP_FULL' ? sanitizeJP : sanitizeAlnum);
    }
  }, true);

  // ---- keydown：1文字キーの素入力を抑止（beforeinput非対応対策）----
  const controlKeys = new Set(['Backspace','Delete','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','Tab','Escape','Enter']);
  document.addEventListener('keydown', e => {
    const t = e.target; if (!isTextLike(t) || t._comp) return;
    const rule = ruleOf(t); if (!rule) return;
    if (e.key && e.key.length === 1){
      if (rule === 'JP_FULL') {
        // 明らかなASCII1文字はブロック
        if (/^[\x20-\x7E]$/.test(e.key)) e.preventDefault();
      } else if (rule === 'ASCII_ALNUM') {
        if (!/[A-Za-z0-9 @!_.-]/.test(e.key)) e.preventDefault(); // 半角スペース( )も許可
      }
    } else if (controlKeys.has(e.key)) {
      // pass
    }
  }, true);

  // ---- 最終保険：inputで常にクリーン ----
  document.addEventListener('input', e => {
    const t = e.target; if (!isTextLike(t) || t._comp) return;
    const rule = ruleOf(t); if (!rule) return;
    const cleaned = (rule === 'JP_FULL') ? sanitizeJP(t.value) : sanitizeAlnum(t.value);
    if (t.value !== cleaned) t.value = cleaned;
  }, true);

  // ---- 入力ヒント（対応端末向け）付与：動的追加にも適用 ----
  const applyInputMode = (el) => {
    const rule = ruleOf(el);
    if (!rule) return;
    // JP_FULL: 日本語IME前提 → 'text' を推奨
    // ASCII_ALNUM: ラテン配列を促す
    el.setAttribute('inputmode', rule === 'ASCII_ALNUM' ? 'latin' : 'text');
    if (rule === 'ASCII_ALNUM') el.setAttribute('autocomplete','off');
  };

  // 既存
  document.querySelectorAll('input,textarea').forEach(el => { if (isTextLike(el)) applyInputMode(el); });

  // 動的
  new MutationObserver(muts => {
    for (const m of muts){
      m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (isTextLike(node)) applyInputMode(node);
        node.querySelectorAll?.('input,textarea').forEach(el => { if (isTextLike(el)) applyInputMode(el); });
      });
    }
  }).observe(document.documentElement, { childList:true, subtree:true });
})();
